import React from 'react';
import { Link } from 'react-router';
import { observer } from 'mobx-react-lite';
import { Notification, useNovu } from '@novu/react';

import { timeDifference } from '../../lib/utils/TimeDifference';

import styles from './notification-item.module.scss';
interface NotificationItemProps {
  notification: Notification;
  onClick?: () => void;
}

export const NotificationItem = observer(
  React.forwardRef<HTMLAnchorElement, NotificationItemProps>(({ notification, onClick }, ref) => {
    console.log(notification);
    const novu = useNovu();
    const { id, createdAt, isRead, subject, body, redirect } = notification;

    const handleNotificationClick = () => {
      onClick && onClick();

      if (!isRead) {
        novu.notifications.read({ notificationId: notification.id });
      }
    };

    return (
      <Link
        className={styles['container']}
        data-testid={`notification-${id}`}
        ref={ref}
        onClick={handleNotificationClick}
        to={redirect?.url}
      >
        <div className={styles['item']} data-read={isRead}>
          <p dangerouslySetInnerHTML={{ __html: subject || body }} />

          <span>{timeDifference(new Date(), createdAt)}</span>
        </div>

        <span className={styles['unread-spot']} data-visible={!isRead} />
      </Link>
    );
  }),
);
